import React from 'react';
import { DeletionControl } from '../components/DeletionControl';

export const LogsPage: React.FC = () => {
  return <DeletionControl />;
};
